










































import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import { SortType } from "../../types";
import CategoryDeleteConfirmation from "../CategoryDeleteConfirmation";
import VaultRenameCategoryModal from "../VaultRenameCategoryModal";

export default defineComponent({
  name: "VaultMenu",
  components: { BaseMenu, CategoryDeleteConfirmation, VaultRenameCategoryModal, BaseIconButton },
  props: {
    selectedCategory: { type: Object as () => VaultCategory, required: true },
    selectedSort: { type: String as () => SortType, required: true },
    categoryFilesLength: { type: Number, default: 0 },
    allowSorting: { type: Boolean, default: false },
    allowManagement: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const showDeleteConfirmation = ref(false);
    const showRenameModal = ref(false);

    const menuItems = computed<BaseMenuItem[]>(() => [
      {
        name: "manage",
        text: $t("Manage"),
      },
      {
        name: "rename",
        text: $t("Rename"),
      },
      {
        name: "delete",
        text: $t("Delete"),
      },
    ]);

    const sortItems = computed<BaseMenuItem[]>(() => [
      {
        name: "sortDesc",
        value: SortType.LAST_USE_TIME_DESC,
        text: $t("Most recent"),
      },
      {
        name: "sortAsc",
        value: SortType.LAST_USE_TIME,
        text: $t("Oldest"),
      },
    ]);

    const isCategoryContainsFiles = computed(() => props.categoryFilesLength > 0);
    const isAvailableSorting = computed(() => props.categoryFilesLength > 1 && props.allowSorting);
    const activeSortItems = computed(() => sortItems.value.find(i => i.value === props.selectedSort));
    const items = computed<BaseMenuItem[]>(() =>
      menuItems.value.filter(item => {
        if (item.name === "manage") {
          return isCategoryContainsFiles.value;
        }

        return !props.selectedCategory.system;
      })
    );

    const onDelete = () => {
      emit("delete:category");
      showDeleteConfirmation.value = false;
    };

    return {
      items,
      sortItems,
      activeSortItems,
      isCategoryContainsFiles,
      isAvailableSorting,
      showDeleteConfirmation,
      showRenameModal,
      SortType,
      onDelete,
    };
  },
});
